import * as React from "react";
type Variant = "default"|"secondary"|"destructive"|"outline"|"success"|"warning"|"info";
export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement>{variant?:Variant}
const css=(...xs:(string|false|null|undefined)[])=>xs.filter(Boolean).join(" ");
const styles:Record<Variant,string>={
  default:"bg-slate-800 text-slate-100 border-slate-700",
  secondary:"bg-slate-900/60 text-slate-200 border-slate-700/60",
  destructive:"bg-rose-600/20 text-rose-200 border-rose-500/30",
  outline:"bg-transparent text-slate-200 border-slate-600/60",
  success:"bg-emerald-600/20 text-emerald-200 border-emerald-500/30",
  warning:"bg-amber-600/20 text-amber-200 border-amber-500/30",
  info:"bg-cyan-600/20 text-cyan-200 border-cyan-500/30",
};
export const Badge = React.forwardRef<HTMLSpanElement,BadgeProps>(({className,variant="secondary",...p},ref)=>(
  <span ref={ref} className={css("inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-medium",styles[variant],className)} {...p}/>
));
Badge.displayName="Badge"; export default Badge;